// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__25GxX","cell":"ColumnAccessor_cell__3gety","firstCellAccent":"ColumnAccessor_firstCellAccent__2WH6O"};